package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.ReplyW500Rounded: ImageVector
    get() {
        if (_replyW500Rounded != null) {
            return _replyW500Rounded!!
        }
        _replyW500Rounded = Builder(name = "ReplyW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(285.44f, 485.5f)
                lineToRelative(106.67f, 106.67f)
                quadToRelative(13.43f, 13.44f, 13.05f, 31.83f)
                quadToRelative(-0.38f, 18.39f, -13.81f, 31.83f)
                quadToRelative(-13.44f, 12.67f, -31.83f, 13.05f)
                quadToRelative(-18.39f, 0.38f, -31.82f, -13.05f)
                lineTo(143.93f, 472.07f)
                quadToRelative(-13.67f, -13.68f, -13.67f, -32.07f)
                reflectiveQuadToRelative(13.67f, -32.07f)
                lineTo(327.7f, 224.17f)
                quadToRelative(12.67f, -12.67f, 31.44f, -12.67f)
                quadToRelative(18.77f, 0.0f, 32.21f, 12.67f)
                quadToRelative(13.43f, 13.44f, 13.43f, 32.21f)
                quadToRelative(0.0f, 18.77f, -13.43f, 32.21f)
                lineTo(285.44f, 394.5f)
                horizontalLineToRelative(357.19f)
                quadToRelative(85.15f, 0.0f, 145.33f, 60.17f)
                quadToRelative(60.17f, 60.18f, 60.17f, 145.33f)
                verticalLineToRelative(122.63f)
                quadToRelative(0.0f, 19.15f, -13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                reflectiveQuadToRelative(-32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                lineTo(757.13f, 600.0f)
                quadToRelative(0.0f, -47.85f, -33.33f, -81.17f)
                quadToRelative(-33.32f, -33.33f, -81.17f, -33.33f)
                lineTo(285.44f, 485.5f)
                close()
            }
        }
        .build()
        return _replyW500Rounded!!
    }

private var _replyW500Rounded: ImageVector? = null
